export default __webpack_public_path__ + "static/media/dina.1b30757b.png";